import { render } from "./uiTodoCard.vue?vue&type=template&id=ce48ef02&scoped=true&ts=true"
import script from "./uiTodoCard.vue?vue&type=script&lang=ts"
export * from "./uiTodoCard.vue?vue&type=script&lang=ts"

import "./uiTodoCard.vue?vue&type=style&index=0&id=ce48ef02&lang=css&scoped=true"

import exportComponent from "C:\\AttiTec\\DogToDo\\dev\\todo-list-vuejs-pwa-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce48ef02"]])

export default __exports__